import { useEffect, useState } from "react";
import LastNameForm from "../../../components/common/input-layout/LastNameForm";
import FirstnameForm from "../../../components/common/input-layout/FirstnameForm";
import InputFullAddress from "../../../components/common/input-layout/InputFullAddress";
import { updateCondolenceMessage, uploadPfMessage } from "../../../api/pro/condolenceReq";
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
import jwt_decode from "jwt-decode";
import { useParams } from "react-router-dom";
import {
    checkRequiredFields,
    getErrorListFromValidation,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import FormButtons from "../../../components/common/FormButtons";
import { toggleDetailsView } from "../../../helper/toggleMenuView";
import Icon from "../../../components/common/Icon";

export default function FormCondolenceMessage({ data, legend, apiCondolenceList, setShowModal, apiDeceasedInfos, isPfOrg }) {
    const [values, setValues] = useState();
    const [showAdditionalInfos, setShowAdditionalInfos] = useState(false);
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken.agency;
    const { selectedCity, setSelectedCity } = useData();

    useEffect(() => {
        if (selectedCity?.city_zip) {
            setValues(prevValues => ({
                ...prevValues,
                address: {
                    ...prevValues?.address,
                    zipcode: selectedCity?.zip,
                    city: selectedCity?.name
                }
            }));
            setSelectedCity(null);
        }
    }, [selectedCity]);

    const onChange = (e) => {
        if (e.target.name === "moderated" && e.target.value == 0) {
            // Message non autorisé : ni la publication Internet ni l'impression ne doivent rester
            // présélectionnées, et l'impression n'est jamais demandée séparément.
            setValues({ ...values, moderated: e.target.value, public: 0, print: 0 })
            validateFormInput(e)
            return;
        }
        if (e.target.name === "moderated" && e.target.value == 1) {
            // Message autorisé : ajouté automatiquement à la liste d'impression, la question ne
            // doit plus être posée séparément.
            setValues({ ...values, moderated: e.target.value, print: 1 })
            validateFormInput(e)
            return;
        }
        setValues({ ...values, [e.target.name]: e.target.value })
        if (e.target.type === "checkbox") {
            setValues({ ...values, [e.target.name]: e.target.checked })
        }
        validateFormInput(e)
    };

    const onChangeAddress = (e) => {
        setValues({ ...values, address: { ...values.address, [e.target.name]: e.target.value } })
        if (e.target.type === "checkbox") {
            setValues({ ...values, address: { ...values.address, [e.target.name]: e.target.checked } })
        }
        validateFormInput(e)
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        if (values?.inputOrg != 1) {
            let body = {
                id: data.id ? data.id : 0,
                message: values?.message,
                moderated: values?.moderated == 1 ? true : false,
                inputOrg: 0,
                new: false,
                web: values?.public == 1 ? true : false,
                public: values?.public == 1 ? true : false,
                print: values?.print == 1 ? true : false,
                civility: values?.civility,
                lastName: values?.lastName,
                firstName: values?.firstName,
                phone: values?.phone,
                email: values?.email,
                address: {
                    addressId: values?.address?.addressId || 0,
                    address: values?.address?.address || "",
                    city: values?.address?.city || "",
                    zipcode: values?.address?.zipcode || "",
                    country: values?.address?.country || "FR"
                }
            }
            await updateCondolenceMessage(body, token)
                .then((response) => {
                    removeErrorList();
                    if (!response?.response?.data?.error) {
                        setShowModal(false)
                        apiCondolenceList();
                        apiDeceasedInfos();
                    } else {
                        getErrorListFromValidation(response?.response?.data?.error)
                    }
                })
        } else if (values?.inputOrg == 1) {
            let body = {
                agencyId: agencyId,
                id: data.id ? data.id : 0,
                deceasedId: id,
                message: values?.message,
                new: false,
                moderated: values?.moderated == 1 ? true : false,
                web: values?.public == 1 ? true : false,
                print: values?.print == 1 ? true : false,
                civility: values?.civility,
                address: {
                    addressId: values?.address?.addressId || 0,
                    address: values?.address?.address || "",
                    city: values?.address?.city || "",
                    zipcode: values?.address?.zipcode || "",
                    country: values?.address?.country || "FR"
                },
                lastName: values?.lastName,
                firstName: values?.firstName,
                phone: values?.phone,
                email: values?.email,
                inputOrg: values?.inputOrg,
            }
            await uploadPfMessage(body, token)
                .then((response) => {
                    removeErrorList();
                    if (!response?.response?.data?.error) {
                        setShowModal(false)
                        apiCondolenceList();
                        apiDeceasedInfos();
                    } else {
                        getErrorListFromValidation(response?.response?.data?.error)
                    }
                })
        }
    }

    const handleRemoveCondolenceModal = (e) => {
        if (e.target.classList.contains("condolence-modal") || e.target.classList.contains("red-button")) {
            setShowModal(false)
        }
    }

    const toggleAdditionalInfos = (e) => {
        e.stopPropagation();
        setShowAdditionalInfos(!showAdditionalInfos);
    }

    useEffect(() => {
        // L'impression n'est jamais demandée séparément : elle suit toujours l'autorisation du
        // message (moderated), que celui-ci soit nouveau ou déjà modéré.
        let initialValues = { ...data, print: data?.moderated == 1 ? 1 : 0 };
        if (data?.new && data.moderated == 0) {
            // Message non autorisé : la publication Internet ne doit pas rester présélectionnée.
            initialValues = { ...initialValues, public: 0 };
        }
        setValues(initialValues)
        setShowAdditionalInfos(false)
    }, [data]);

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate className="condolence-form-compact">
            <fieldset className="condoleances">
                <Icon span={legend} source="fa-solid fa-message" />
                <div className="public-notice-compact">
                    <span className="user-name">
                        {isPfOrg 
                            ? `${data?.firstName || ''} ${data?.lastName || ''}`.trim()
                            : `${data?.firstName || ''} ${data?.lastName || ''}`.trim()
                        }
                    </span> <b>{data?.public ? "a souhaité que son message soit publié sur Internet." : "n'a pas souhaité que son message soit publié sur Internet."}</b>
                </div>

                <div className="html-textarea">
                        <textarea name="message" id="message" value={values?.message} onChange={onChange} placeholder="Votre message ici..." required rows="8" className="message-textarea"></textarea>
                </div>

                <div className="form-input">
                    <label htmlFor="moderated" className="required">J'autorise ce message (Message convenable, pas d'éléments diffamatoires)</label>
                    <input type="radio" name="moderated" value={1} id="moderated1" required onChange={onChange}
                           checked={values?.moderated == 1}/><label htmlFor="moderated1">Oui</label>
                    <input type="radio" name="moderated" value={0} id="moderated0" onChange={onChange}
                           checked={values?.moderated == 0}/><label htmlFor="moderated0">Non</label>
                </div>

                {(decodedToken?.roles?.includes("ROLE_PREVIOUS_ADMIN") || decodedToken?.roles?.includes("ROLE_PF") || decodedToken?.roles?.includes("ROLE_UPF")) &&
                    <div className="form-input">
                        <label htmlFor="public" className="required">J'autorise la publication sur Internet (Les messages ne doivent pas exposer d'informations personnelles, ou trop intimes)</label>
                        <input type="radio" name="public" value={1} id="public1" required onChange={onChange}
                               checked={values?.public == 1}/><label htmlFor="public1">Oui</label>
                        <input type="radio" name="public" value={0} id="public0" onChange={onChange}
                               checked={values?.public == 0}/><label htmlFor="public0">Non</label>
                    </div>
                }
            </fieldset>

            {values?.inputOrg != 1 &&
                <fieldset className={`coordinates-compact ${showAdditionalInfos ? "active" : ""}`}>
                    <button type="button" className="arrow" onClick={toggleAdditionalInfos}>
                        <i className={`fa ${showAdditionalInfos ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                    </button>
                    {showAdditionalInfos && (
                        <>
                            <div className="form-group">
                                <div className="form-input">
                                    <label htmlFor="civility">Civilité</label>
                                    <select name="civility" onChange={onChange} value={values?.civility || ""}>
                                        <option disabled={true} value="">Civilité</option>
                                        <option value="M">Monsieur</option>
                                        <option value="MME">Madame</option>
                                        <option value="METMME">Monsieur et Madame</option>
                                        <option value="MMES">Mesdames</option>
                                        <option value="MS">Messieurs</option>
                                        <option value="AUCUNE">Aucune civilité</option>
                                    </select>
                                </div>
                                <LastNameForm required={true} onChange={onChange} value={values?.lastName} />
                                <FirstnameForm onChange={onChange} value={values?.firstName} />
                            </div>

                            <InputFullAddress
                                type="actual"
                                addressField="address"
                                zipField="zipcode"
                                cityField="city"
                                countryField="country"
                                address={values?.address?.address}
                                city={values?.address?.city}
                                zipcode={values?.address?.zipcode}
                                country={values?.address?.country || "FR"}
                                compClass="address_comp_none"
                                onChange={onChangeAddress}
                            />
                            <div className="form-input">
                                <label htmlFor="phone">Téléphone</label>
                                <input type="text" name="phone" value={values?.phone || ""} onChange={onChange} placeholder="Téléphone" />
                            </div>
                            <div className="form-input">
                                <label htmlFor="email">Email</label>
                                <input type="email" name="email" value={values?.email || ""} onChange={onChange} placeholder="Email" />
                            </div>
                        </>
                    )}
                    <div className="errors"></div>
                </fieldset>
            }
            <FormButtons handleRemoveModal={handleRemoveCondolenceModal} />
        </form>
    )
}
